/**
 * Analytics Module
 *
 * Re-exports all analytics functionality for convenient imports.
 *
 * Usage:
 *   import { useAnalytics, EVENTS, PLACEMENTS, trackCtaClick } from '@/lib/analytics';
 */

// Constants and Types
export {
  type AddPaymentInfoParams,
  type AnalysisCompleteParams,
  type AnalysisStartParams,
  AUTH_METHODS,
  type AuthMethod,
  type BaseEventParams,
  type BeginCheckoutParams,
  type ChatMessageSendParams,
  type ChatShareParams,
  type ChatStartParams,
  CTA_IDS,
  type CtaClickParams,
  type CtaId,
  EVENTS,
  type EventName,
  FORM_TYPES,
  type FormStartParams,
  type FormSubmitParams,
  type FormType,
  type GenerateLeadParams,
  type LoginParams,
  type NewsletterSignupParams,
  PLACEMENTS,
  type Placement,
  type PurchaseParams,
  SHARE_PLATFORMS,
  type ShareParams,
  type SharePlatform,
  type SignUpParams,
  TIERS,
  type Tier,
  type UpgradeViewParams,
} from "./events";

// GTM/DataLayer Functions
export {
  clearUserProperties,
  isGtmConfigured,
  pushToDataLayer,
  setUserProperties,
  trackAddPaymentInfo,
  trackAnalysisComplete,
  trackAnalysisStart,
  trackBeginCheckout,
  trackChatMessageSend,
  trackChatShare,
  trackChatStart,
  trackCtaClick,
  trackEvent,
  trackFormStart,
  trackFormSubmit,
  trackGenerateLead,
  trackLogin,
  trackNewsletterSignup,
  trackPurchase,
  trackShare,
  trackSignUp,
  trackUpgradeView,
} from "./gtm";

// React Hooks
export {
  type UseAnalyticsReturn,
  type UseCheckoutTrackingOptions,
  type UseCheckoutTrackingReturn,
  type UseFormTrackingOptions,
  type UseFormTrackingReturn,
  useAnalytics,
  useCheckoutTracking,
  useFormTracking,
} from "./use-analytics";
